import { Form } from '@unform/web';
import styled from 'styled-components';

import { ButtonConfirm } from '../../../../components/ButtonConfirm';
import { InputText } from '../../../../components/InputText';
import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
`;

export const Discard = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};
  cursor: pointer;

  font-size: 13px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    color: ${colors.onSurface};
  }
`;

export const Card = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.lg};
  padding: 32px;

  & > * {
    margin-bottom: 16px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Input = styled(InputText)``;

export const Info = styled(TextInfo)`
  margin-bottom: 4px;
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const ExistingUserTag = styled.p`
  display: flex;
  align-items: center;

  padding: 10px 14px;
  border-radius: ${radius.DEFAULT};
  background-color: ${colors.primary}1a;

  font-size: 12px;
  font-weight: 600;
  color: ${colors.primary};
`;

export const InviteToggleRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  padding: 16px 20px;
  border-radius: ${radius.md};
  background-color: ${colors.surfaceContainer};

  p {
    font-size: 13px;
    font-weight: 600;
    color: ${colors.onSurface};
  }

  span {
    font-size: 12px;
    color: ${colors.onSurfaceVariant};
  }
`;

export const Submit = styled(ButtonConfirm)`
  align-self: center;
  margin-top: 24px;
`;
